(function () {
  function initTrendingArticlesSlider(container) {
    if (!container) return;

    const track = container.querySelector('.trending-articles-slider');
    if (!track) return;

    // Add JS class to enable slider styles
    track.classList.add('js-slider');


    const controlsWrapper = document.createElement('div');
    controlsWrapper.className = 'trending-articles-controls-wrapper';

    // Create controls
    const controls = document.createElement('div');
    controls.className = 'trending-articles-controls';
    const prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'prev';
    prev.setAttribute('aria-label', 'Previous');
    prev.innerHTML = '<svg width="16" height="27" viewBox="0 0 16 27" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path d="M1.00028 12.9213L1.97929 13.9221L14.3442 1.82596L13.3652 0.825195L1.00028 12.9213Z" fill="#252525" stroke="black"/>\n  <path d="M1.00028 13.5785L1.97929 12.5778L14.3442 24.6739L13.3652 25.6747L1.00028 13.5785Z" fill="#252525" stroke="black"/>\n</svg>';

    const next = document.createElement('button');
    next.type = 'button';
    next.className = 'next';
    next.setAttribute('aria-label', 'Next');
    next.innerHTML = '<svg width="16" height="27" viewBox="0 0 16 27" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path d="M14.6892 12.9213L13.7102 13.9221L1.34521 1.82596L2.32422 0.825195L14.6892 12.9213Z" fill="#252525" stroke="black"/>\n  <path d="M14.6892 13.5785L13.7102 12.5778L1.34521 24.6739L2.32422 25.6747L14.6892 13.5785Z" fill="#252525" stroke="black"/>\n</svg>';

    controls.appendChild(prev);
    controls.appendChild(next);
    controlsWrapper.appendChild(controls)

    // Insert controls before the track so they appear above the card list
    container.insertBefore(controlsWrapper, track);

  const cards = Array.from(track.querySelectorAll('.trending-article-card'));
    if (!cards.length) return;

    const cardWidth = () => cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 16);

    function updateButtons() {
      // Disable prev if already at left-most
      prev.disabled = track.scrollLeft <= 0;
      // Disable next if at right-most
      next.disabled = Math.ceil(track.scrollLeft + track.clientWidth) >= track.scrollWidth - 1;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -cardWidth(), behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      track.scrollBy({ left: cardWidth(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', throttle(updateButtons, 100));
    updateButtons();

    // Drag to scroll
    let isDown = false;
    let startX, scrollLeft;

    track.addEventListener('pointerdown', (e) => {
      // don't start dragging if the user interacted with an interactive child
      // such as video overlay, iframe, native video, links or buttons — allow those elements to handle the event
      try {
        const interactive = e.target && (e.target.closest && (
          e.target.closest('.wg-video-overlay') ||
          e.target.closest('iframe') ||
          e.target.closest('video') ||
          e.target.closest('button') ||
          e.target.closest('a')
        ));
        if (interactive) return;
      } catch (err) {}

      isDown = true;
      try { track.setPointerCapture(e.pointerId); } catch (err) {}
      track.classList.add('is-dragging');
      startX = e.clientX;
      scrollLeft = track.scrollLeft;
    });

    track.addEventListener('pointermove', (e) => {
      if (!isDown) return;
      const x = e.clientX;
      const walk = (startX - x);
      track.scrollLeft = scrollLeft + walk;
    });

    track.addEventListener('pointerup', (e) => {
      isDown = false;
      try { track.releasePointerCapture(e.pointerId); } catch (err) { }
      track.classList.remove('is-dragging');
    });

    track.addEventListener('pointerleave', () => {
      isDown = false;
      track.classList.remove('is-dragging');
    });

    // keyboard support
    container.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') next.click();
      if (e.key === 'ArrowLeft') prev.click();
    });

    // utility: throttle
    function throttle(fn, wait) {
      let time = Date.now();
      return function () {
        if ((time + wait - Date.now()) < 0) {
          fn.apply(this, arguments);
          time = Date.now();
        }
      };
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    // inicializa o slider do Unboxing (reaproveita initTrendingArticlesSlider)
    document.querySelectorAll('.home-unboxing-members-section').forEach((sec) => {
      // só inicializa se existir o track com a classe esperada
      const track = sec.querySelector('#unboxing-video-cards.trending-articles-slider');
      if (track && typeof initTrendingArticlesSlider === 'function') {
        initTrendingArticlesSlider(sec);
      }
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    const winnersSection = document.querySelector('#wheel-winners-section');
    if (winnersSection) {
      initTrendingArticlesSlider(winnersSection);
    }
  });

  // Init on DOMContentLoaded for each section instance
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('#trending-articles-section').forEach((sec) => initTrendingArticlesSlider(sec));
  });
})();


